import { render, staticRenderFns } from "./WillPeopleModal.vue?vue&type=template&id=db74b382"
import script from "./WillPeopleModal.vue?vue&type=script&lang=js"
export * from "./WillPeopleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports